export default __webpack_public_path__ + "static/media/comment-Icon.07644e78.svg";